import { InputContainer, Input, Prefix, Suffix } from './styles'
import I from 'ui/elements/I'

InputContainer.Input = Input
InputContainer.I = I
InputContainer.Prefix = Prefix
InputContainer.Suffix = Suffix

export default InputContainer
